export const tokenConfigs = [
    {
        key: "seth",
        name: "SETH",
        fullName: "",
        desc: "Sepolia",
        exchangeRate: 2,
        contractAddress: "0xA6Dd82B9a15e0425020F2fB14da38c8E93a8444c", //sepolia reserve contract
        transferAddress: "0xbEA85Fef1f4EBCe2c3248084b5b023C727c4D477",
        listData: [
            { url: "https://sepoliafaucet.com/", mark: "每天 1 Sepolia ETH" },
            { url: "https://sepolia-faucet.pk910.de/", mark: "需要通过挖矿获取" },
            { url: "https://grabteeth.xyz/", mark: "在 2022 年11月之前部署过合约的，可以领 10 个" },
            { url: "https://faucet.quicknode.com/drip", mark: "在 2022 年11月之前部署过合约的，可以领 10 个" },
            { url: "https://faucets.chain.link/", mark: "" },
            { url: "https://www.infura.io/faucet?ref=chaintool.tech", mark: "" }
        ]
    },
    {
        key: "geth",
        name: "GETH",
        fullName: "",
        desc: "Goerli",
        exchangeRate: 1,
        listData: [
            { url: "https://faucet.paradigm.xyz", mark: "可领取ETH、wETH、DAI、NFTs，要求登录Twitter" },
            { url: "https://grabteeth.xyz/", mark: "在 2022 年11月之前部署过合约的，可以领 10 个" },
            { url: "https://unitap.app/", mark: "" },
            { url: "https://faucet.quicknode.com/drip", mark: "" },
            { url: "https://www.allthatnode.com/faucet/ethereum.dsrv", mark: "" }
        ]
    },
    {
        key: "tmatic",
        name: "tMATIC",
        fullName: "",
        desc: "Polygon Testnet",
        exchangeRate: 1,
        listData: [
            { url: "https://www.alchemy.com/faucets/polygon-amoy", mark: "" },
            { url: "https://faucet.polygon.technology", mark: "" },
        ]
    },
    {
        key: "sol",
        name: "SOL",
        fullName: "",
        desc: "Solana Devent",
        exchangeRate: 1,
        listData: [{ url: "https://faucet.quicknode.com/solana", mark: "要求在以太坊主网上持有至少 0.001 ETH才能领取" }]
    },
    {
        key: "opeth",
        name: "opETH",
        fullName: "",
        desc: "Optimism Sepolia",
        exchangeRate: 1,
        listData: [
            { url: "https://www.alchemy.com/faucets/optimism-sepolia", mark: "每天 0.5 opEth, 需要主网钱包至少有 0.001 ETH" },
            { url: "https://learnweb3.io/faucets/optimism_sepolia", mark: "每天 0.01 opEth" }
        ]
    },
    {
        key: "arbeth",
        name: "arbETH",
        fullName: "",
        desc: "Arbitrum Sepolia",
        exchangeRate: 1,
        listData: [
            { url: "https://www.alchemy.com/faucets/arbitrum-sepolia", mark: "每天 0.5 arbEth, 需要主网钱包至少有 0.001 ETH" },
            { url: "https://learnweb3.io/faucets/arbitrum_sepolia", mark: "每天 0.01 arbEth" },
        ]
    },
    {
        key: "tbnb",
        name: "tBNB",
        fullName: "",
        desc: "BNB Chain Testnet",
        exchangeRate: 1,
        listData: [{ url: "https://unitap.app/gas-tap", mark: "" }, { url: "https://testnet.bnbchain.org/faucet-smart", mark: "" }]
    },
    {
        key: "xdai",
        name: "xDai",
        fullName: "",
        desc: "Gnosis Chain",
        exchangeRate: 1,
        listData: [{ url: "https://stakely.io/faucet/xdai-chain", mark: "" }]
    },
    {
        key: "avax",
        name: "AVAX",
        fullName: "",
        desc: "Avalanche Testnet",
        exchangeRate: 1,
        listData: [{ url: "https://faucet.avax-test.network", mark: "" }]
    },

    {
        key: "okt",
        name: "OKT",
        fullName: "",
        desc: "OKExChain Testnet",
        exchangeRate: 1,
        listData: [
            { url: "https://gitter.im/okexchain-testnet/faucet", mark: "" },
            { url: "https://discord.gg/B5nMs6qK5F" }]
    },

    {
        key: "one",
        name: "ONE",
        fullName: "",
        desc: "Harmony Testnet",
        exchangeRate: 1,
        listData: [
            { url: "https://faucet.pops.one", mark: "包含Shard 0、Shard 1、Shard 2、Shard 3" },
        ]
    },
    {
        key: "aeth",
        name: "ETH",
        fullName: "",
        desc: "Aurora Testnet",
        exchangeRate: 1,
        listData: [
            { url: "https://aurora.dev/faucet", mark: "" },
        ]
    },
    {
        key: "celo",
        name: "CELO",
        fullName: "",
        desc: "Celo Alfajores Testnet",
        exchangeRate: 1,
        listData: [
            { url: "https://faucet.celo.org/", mark: "需要使用Github进行身份验证" },
        ]
    },
    {
        key: "cubet",
        name: "CUBET",
        fullName: "",
        desc: "Cube Chain Testnet",
        exchangeRate: 1,
        listData: [
            { url: "https://faucet.cube.network/", mark: "" },
        ]
    },
].reduce((obj, item) => {
    obj[item.key] = item;
    return obj;
}, {});